import { render, staticRenderFns } from "./AccountsTable.vue?vue&type=template&id=242f0f65&scoped=true&"
import script from "./AccountsTable.vue?vue&type=script&lang=js&"
export * from "./AccountsTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountsTable.vue?vue&type=style&index=0&id=242f0f65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f0f65",
  null
  
)

export default component.exports